
import React, { forwardRef, useState } from 'react'
import { Session } from '../Utils'


type HeatMapControlsProps = {
    display: boolean;
    clearfunc: (event: React.MouseEvent<HTMLButtonElement>) => void;
    forwardfunc: (event: React.MouseEvent<HTMLButtonElement>) => void;
    backwardfunc: (event: React.MouseEvent<HTMLButtonElement>) => void;
    playfunc: (event: React.MouseEvent<HTMLButtonElement>) => void;
    resetfunc?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    changefunc?: (event: React.SyntheticEvent<HTMLSelectElement>) => void;
    pause_func?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    dateval: string | null;
    distance: string;
    driver: Record<string, any> | null;
    startday: number;
    playmode: boolean;
    set_date_func: (datestr:string) => void ;
}


const HeatMapControl = forwardRef<HTMLSelectElement, HeatMapControlsProps>(
    ({
        display, clearfunc, forwardfunc,
        backwardfunc, playfunc, resetfunc,
        changefunc, dateval, distance,
        driver, startday, playmode, pause_func, set_date_func }, ref) => {
 
        const [btn_display, setBtnDisplay] = useState(false);
        const [selected_date, setDate] = useState('');


        if (!display) {
            return null
        }   

        const openCalendar = (event: React.ChangeEvent<HTMLInputElement>) => {
            setDate(event.target.value);
            setBtnDisplay(true)
        }


        return (
            <div className='heatmap_sec'>
                <h3 className='text-center p-3'> Movement History </h3>
                <table className='table mb-0'>
                    <tbody>

                        <tr>
                            <td> Date:  </td>
                            <td className='d-flex flex-row'> 
                                {dateval}  {" "}
                                <span className={'d-flex flex-row'}> 
                                    <input onChange={openCalendar} id='calendainput' style={{width: '20px', border: 'none', zIndex:0, marginLeft:'5px', marginRight: '15px'}} type='date' /> 
                                    <button  className={ btn_display? 'btn btn-sm btn-info' : 'btn btn-sm btn-info d-none'} onClick={()=>(set_date_func(selected_date), setBtnDisplay(!btn_display))}> Apply  </button>
                                 </span> 
                            </td>
                        </tr>
                        <tr>
                            <td> Vehicle:  </td>
                            <td> {driver!.name} </td>
                        </tr>
                        <tr>
                            <td> Distance Covered </td>
                            <td> {distance} </td>
                        </tr>
                        <tr>
                            <td> Replay Mode </td>
                            <td>
                                <select id='move_mode'
                                    name='move_mode'
                                    onChange={changefunc} className='form-control'
                                    ref={ref} defaultValue={1}>
                                    <option value={0}> Select Mode </option>
                                    <option value={1}> Slow Replay</option>
                                    <option value={2}> Intermittent Replay</option>
                                    <option value={3}> Full Replay </option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h4 className='bg-white mb-0 text-center p-4'> Controls </h4>
                <p className='d-flex justify-content-around bg-white p-4 pb-5 mb-0'>
                    <button type='button' onClick={backwardfunc}
                        style={{ display: startday === Number(Session.get("max_history_count")) ? 'none' : 'inline-block' }}
                        className={'btn btn-success'}>
                        <i className="fa fa-fast-backward" aria-hidden="true"></i>
                    </button> &nbsp;
                    {
                        playmode ? (
                            <button type='button'
                                title={'pause movement history'}
                                onClick={pause_func} className={'btn btn-primary'}>
                                <i className="fa fa-pause" aria-hidden="true"></i>
                            </button>
                        ) : (
                            <button type='button'
                                title={'play movement history'}
                                onClick={playfunc} className={'btn btn-primary'}>

                                <i className="fa fa-play" aria-hidden="true"></i>

                            </button>
                        )
                    }
                    &nbsp;
                    <button style={{ display: startday === 0 ? 'none' : 'inline-block' }}
                        onClick={forwardfunc} className={'btn btn-success'}>
                        <i className="fa fa-fast-forward" aria-hidden="true"></i>
                    </button> &nbsp;

                    <button onClick={resetfunc}
                        className={'btn btn-warning'} title='Reset movement data'>
                        <i className="fa fa-reply" aria-hidden="true"></i>
                    </button> &nbsp;
                    <button onClick={clearfunc} className={'btn btn-danger'}
                        title="Clear movement data">
                        <i className="fa fa-times-circle" aria-hidden="true"></i>
                    </button>

                </p>
            </div>
        )
    }
)

export default HeatMapControl